var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11038 6.00033H4.89038C5.99705 6.00033 6.44705 5.21699 5.89705 4.26033L5.65038 3.83366C5.59038 3.73033 5.48038 3.66699 5.36038 3.66699L2.64038 3.66699C2.52038 3.66699 2.41038 3.73033 2.35038 3.83366L2.10372 4.26033C1.55372 5.21699 2.00372 6.00033 3.11038 6.00033Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.93051 3.33319H5.07384C5.20384 3.33319 5.28384 3.19319 5.21717 3.08319L5.00384 2.71652C4.45384 1.75986 3.54717 1.75986 2.99717 2.71652L2.78384 3.08319C2.72051 3.19319 2.80051 3.33319 2.93051 3.33319Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLight);
export default __webpack_public_path__ + "static/media/arrow-up-light.ee8c775f6713e5a76b02610bb46027c2.svg";
export { ForwardRef as ReactComponent };